import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class AssetTypesService {
  static getAll(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}asset-types${params}`).then((data) => {
        resolve({ assetTypes: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}asset-types/listAll`).then((data) => {
        resolve({ assetTypes: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(assetTypeId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}asset-types/${assetTypeId}`).then((data) => {
        resolve({ assetType: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(assetType) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}asset-types`, assetType).then((data) => {
        resolve({ assetType: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }  

  static update(assetTypeId, assetType) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}asset-types/${assetTypeId}`, assetType).then((data) => {
        resolve({ assetType: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }  

  static delete(assetTypeId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}asset-types/${assetTypeId}`).then((data) => {
        resolve({ response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }  
}

export default AssetTypesService;
